import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { Button } from "@/components/ui/button";

export default function BillingReturn() {
  const { t } = useI18n();
  const [sp] = useSearchParams();
  const failed = sp.get("failed");
  const [plan, setPlan] = useState(null);

  useEffect(() => { if (!failed) api.get("/billing/me").then((r) => setPlan(r.data.plan)).catch(() => {}); }, [failed]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#0a0a0c] text-zinc-100 px-6">
      <div className="max-w-md text-center">
        {failed ? <XCircle className="mx-auto h-12 w-12 text-rose-400" /> : <CheckCircle2 className="mx-auto h-12 w-12 text-emerald-400" />}
        <h1 className="mt-4 font-serif-display text-3xl font-light">
          {failed ? t("billing.cancelled") : t("billing.thanks")}
        </h1>
        <p className="mt-3 text-zinc-400 text-sm">
          {failed
            ? t("billing.cancelledP")
            : `${t("billing.pendingP")}${plan && plan !== "free" ? t("billing.currentPlan", { plan }) : "."}`}
        </p>
        <div className="mt-6 flex items-center justify-center gap-3">
          <Link to="/dashboard"><Button className="h-11 rounded-full bg-zinc-50 text-zinc-950 hover:bg-white px-6">{t("billing.toDashboard")}</Button></Link>
          <Link to="/pricing"><Button variant="outline" className="h-11 rounded-full border-zinc-700 px-6">{t("billing.viewPlans")}</Button></Link>
        </div>
      </div>
    </div>
  );
}
